import React, { Component } from "react";
import moment from "moment";

import mixpanel from "../../../../../lib/mixPanel";
import Api from "../../../../../lib/componentApi";
import getDeliveryFee from "../../../../../lib/getDeliveryFee";
import getAppErrors from "../../../../../lib/appErrors";
import getPromoCodeInfo from "../../../../../lib/getPromoCodeInfo";

export default class AddPromoCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoCode: "",
      message: "",
      addNew: false,
      selectedPromoCode: null,
      calculatedDeliveryFee: 0,
      title: ""
    };
  }
  componentDidMount() {
    this.getDeliveryFee();
  }
  getDeliveryFee = () => {
    const { deliveryFee, subTotal } = this.props;
    let delivery = null;
    if (typeof deliveryFee === "object") {
      delivery = getDeliveryFee(deliveryFee, subTotal);
    } else {
      delivery = deliveryFee;
    }
    if (typeof delivery === "number") {
      this.setState({ calculatedDeliveryFee: delivery });
    }
  };
  handleSubmitCode = () => {
    const { promoCode } = this.state;
    const { closeDefaultStatus, points } = this.props;
    Api.post("/api/use/promo/code", { promoCode }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (typeof response.code === "number") {
        if (response.code === 2601) {
          this.setState({
            message: "Your promo code is not valid."
          });
        } else {
          const errorMessage = getAppErrors(response.code);
          this.setState({
            message: (errorMessage && errorMessage.message) || response.message
          });
        }
      } else {
        const { calculatedDeliveryFee } = this.state;
        if (response.gainType === "FREE_DELIVERY" && !calculatedDeliveryFee) {
          this.setState({
            message:
              "Delivery is free already! This promotion does not apply to this restaurant."
          });
        } else {
          const { title, message } = getPromoCodeInfo(
            response.gainStage,
            response.gainType,
            response.gainAmount,
            response.afterGainAmount,
            response.beforeGainAmount,
            points
          );
          if (message) {
            this.setState({ title, message }, () => {});
          } else {
            const promo = {
              amount: response.gainAmount,
              code: response.code,
              type: response.gainType,
              beforeAmount: response.gainAmount
            };
            closeDefaultStatus("addPromoCode", { promo });
          }
        }
      }
    });
  };
  handleChangeCode = e => {
    e.preventDefault();
    this.setState({
      promoCode: e.target.value
    });
  };
  renderManuelAddPromotions = () => {
    const { promoCode, message, title } = this.state;
    const { closeDefaultStatus } = this.props;
    return (
      <React.Fragment>
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back">
              <a href="javascript: void(0)" />
              <h4>
                {title || ((message && "Oops") || "Select a Promotion Code")}
              </h4>
              <a
                href="javascript: void(0)"
                onClick={() => closeDefaultStatus("addPromoCode")}
                className="close"
              >
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row center-sm">
                <div className="col-sm-6">
                  <div className="add-promo-code white-bg">
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChangeCode}
                      placeholder="Enter Promo Code"
                      value={promoCode.toUpperCase()}
                    />
                  </div>
                  <div className="use-buttons">
                    <button
                      className={
                        (promoCode && "btn btn-blue") || "btn btn-gray"
                      }
                      onClick={this.handleSubmitCode}
                      disabled={!promoCode}
                    >
                      Continue
                    </button>
                    <button
                      className="btn btn-gray"
                      onClick={() => closeDefaultStatus("addPromoCode")}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              {/* .row */}
            </div>
            {/* .modal-body */}
          </div>
          {/* .modal */}
        </div>
      </React.Fragment>
    );
  };
  getPromotionsText = promotion => {
    let dateText, bodyText;
    dateText = moment(promotion.createdAt).format("DD-MM-YYYY");

    switch (promotion.gainType) {
      case "AMOUNT":
        bodyText = `£${parseFloat(promotion.gainAmount).toFixed(
          2
        )} ${(promotion.restaurantName && " - " + promotion.restaurantName) ||
          ""}`;
        break;
      case "PERCENT":
        bodyText = `%${promotion.gainAmount} ${(promotion.restaurantName &&
          " - " + promotion.restaurantName) ||
          ""}`;
        break;
      case "POINTS":
        bodyText = `+${promotion.gainAmount} eCoins. ${(promotion.restaurantName &&
          " - " + promotion.restaurantName) ||
          ""}`;
        break;
      case "FREE_DELIVERY":
        bodyText = `Free Delivery ${(promotion.restaurantName &&
          " - " + promotion.restaurantName) ||
          ""}`;
        break;
    }
    return { dateText, bodyText };
  };
  handleSelectPromotion = () => {
    const { selectedPromoCode } = this.state;
    const { closeDefaultStatus, points } = this.props;
    Api.post(
      "/api/select/promo/code",
      { promoCode: selectedPromoCode },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (typeof response.code === "number") {
          mixpanel.people.set({
            "Promo Applied": false,
            Platform: "Web"
          });
          const errorMessage = getAppErrors(response.code);
          this.setState({
            message: (errorMessage && errorMessage.message) || response.message
          });
        } else {
          mixpanel.people.set({ "Promo Applied": true, Platform: "Web" });
          const { title, message } = getPromoCodeInfo(
            response.gainStage,
            response.gainType,
            response.gainAmount,
            response.afterGainAmount,
            response.beforeGainAmount,
            points
          );
          const promo = {
            amount: response.gainAmount,
            code: response.code,
            type: response.gainType,
            beforeAmount: response.gainAmount
          };
          if (message) {
            this.setState({ title, message });
          } else {
            closeDefaultStatus("addPromoCode", promo);
          }
        }
      }
    );
  };
  handleClickPromotion = promoCode => {
    this.setState({
      selectedPromoCode: promoCode
    });
  };
  renderSelectPromotions = () => {
    const { useAblePromoCodes, closeDefaultStatus } = this.props;
    const { selectedPromoCode } = this.state;
    return (
      <React.Fragment>
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back">
              <a href="javascript: void(0)" />
              <h4>Select a Promotion Code</h4>
              <a
                href="javascript: void(0)"
                onClick={() => closeDefaultStatus("addPromoCode")}
                className="close"
              >
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row center-sm">
                <div className="col-sm-6">
                  <div className="address-list add-promo-list mt-10px">
                    <a
                      href="javascript: void(0)"
                      onClick={() => this.setState({ addNew: true })}
                    >
                      <i className="icon icon-close icon-plus" />
                      <span>Add New</span>
                    </a>
                    <ul>
                      {useAblePromoCodes.map(promoCode => {
                        const { dateText, bodyText } = this.getPromotionsText(
                          promoCode
                        );
                        let className;
                        if (promoCode.useAble) {
                          className = "use-able";
                        } else {
                          className = "line-through";
                        }
                        return (
                          <li
                            className={className}
                            key={promoCode.id}
                            onClick={() =>
                              className === "use-able" &&
                              this.handleClickPromotion(promoCode.code)
                            }
                          >
                            <a
                              href="javascript: void(0)"
                              className="d-flex justify-content-between align-items-center"
                            >
                              <div>
                                <p>#{promoCode.code}</p>
                                <p className="bold">{bodyText}</p>
                                <p>{dateText}</p>
                              </div>
                              {(promoCode.code === selectedPromoCode && (
                                <div>
                                  <div className="visible-xs">
                                    <icon className="icon icon-ok-green" />
                                  </div>
                                  <div className="hide-xs">
                                    <icon className="icon icon-okay-2" />
                                  </div>
                                </div>
                              )) || <noscript />}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                    <div className="use-buttons">
                      <button
                        className={`btn btn-${(selectedPromoCode && "blue") ||
                          "gray"}`}
                        onClick={this.handleSelectPromotion}
                      >
                        Continue
                      </button>
                      <button
                        className="btn btn-gray"
                        onClick={() => closeDefaultStatus("addPromoCode")}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
                {/* .col-sm-6 */}
              </div>
              {/* .row */}
            </div>
            {/* .modal-body */}
          </div>
          {/* .modal */}
        </div>
      </React.Fragment>
    );
  };
  render() {
    const { closeDefaultStatus, useAblePromoCodes } = this.props;
    const { message, addNew, title } = this.state;
    return (
      <React.Fragment>
        {(message && (
          <React.Fragment>
            <div>
              <div className="modal-bg" />
              <div className="modal">
                {/* Header */}
                <div className="head-general with-back">
                  <a href="javascript: void(0)" />
                  <h4>
                    {title ||
                      ((message && "Oops") || "Select a Promotion Code")}
                  </h4>
                  <a
                    href="javascript: void(0)"
                    onClick={() => closeDefaultStatus("addPromoCode")}
                    className="close"
                  >
                    <icon className="icon icon-close" />
                  </a>
                </div>
                {/* Header */}

                <div className="modal-body">
                  <div className="row center-sm">
                    <div className="col-sm-12">
                      <div className="promo-error white-bg">
                        <p>{message}</p>
                      </div>
                      <div className="use-buttons">
                        <button
                          className="btn btn-blue"
                          onClick={() => closeDefaultStatus("addPromoCode")}
                        >
                          Go back to order
                        </button>
                      </div>
                    </div>
                    {/* .col-sm-6 */}
                  </div>
                  {/* .row-body */}
                </div>
                {/* .modal-body */}
              </div>
              {/* .modal */}
            </div>
          </React.Fragment>
        )) ||
          ((useAblePromoCodes &&
            useAblePromoCodes.length &&
            ((addNew && this.renderManuelAddPromotions()) ||
              this.renderSelectPromotions())) ||
            this.renderManuelAddPromotions())}
      </React.Fragment>
    );
  }
}
